import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function Dashboard(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.667 15.556H4.444V7.778H6.667V15.556ZM11.111 15.556H8.889V4.444H11.111V15.556ZM15.555 15.556H13.333V11.111H15.555V15.556ZM17.777 17.778H2.222V2.222H17.778L17.777 17.778ZM17.778 0H2.222C1.63326 0.00184602 1.06915 0.236542 0.652848 0.652848C0.236542 1.06915 0.00184602 1.63326 0 2.222V17.778C0.00184602 18.3667 0.236542 18.9308 0.652848 19.3472C1.06915 19.7635 1.63326 19.9982 2.222 20H17.778C18.3667 19.9982 18.9308 19.7635 19.3472 19.3472C19.7635 18.9308 19.9982 18.3667 20 17.778V2.222C19.9982 1.63326 19.7635 1.06915 19.3472 0.652848C18.9308 0.236542 18.3667 0.00184602 17.778 0Z"
        fill={color || "#bbb"}
      />
    </svg>
  );
}
